import { render, staticRenderFns } from "./FieldToggle.vue?vue&type=template&id=4870ab76&scoped=true"
import script from "./FieldToggle.vue?vue&type=script&lang=js"
export * from "./FieldToggle.vue?vue&type=script&lang=js"
import style0 from "./FieldToggle.vue?vue&type=style&index=0&id=4870ab76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870ab76",
  null
  
)

export default component.exports